var ResponseType;
(function(ResponseType2) {
  ResponseType2["BUSINESS_NOTICE"] = "BUSINESS_NOTICE";
  ResponseType2["BUSINESS_ERROR"] = "BUSINESS_ERROR";
  ResponseType2["SYSTEM_ERROR"] = "SYSTEM_ERROR";
})(ResponseType || (ResponseType = {}));
const urlPrefixMap = {
  "/designapi": {
    noticeRange: [23e4, 230400],
    businessErrorRange: [230401, 230800],
    systemErrorRange: [230801, 230999]
  },
  "/unifiedcheck": {
    noticeRange: [24e4, 240400],
    businessErrorRange: [240401, 240900],
    systemErrorRange: [240901, 240999]
  },
  "/designordercenter": {
    noticeRange: [
      [36e4, 360400],
      [100018, 100018]
    ],
    businessErrorRange: [360401, 360800],
    systemErrorRange: [360801, 360999]
  },
  "/designordercentermsg": {
    noticeRange: [
      [36e4, 360400],
      [100018, 100018]
    ],
    businessErrorRange: [360401, 360800],
    systemErrorRange: [360801, 360999]
  },
  "/quotation": {
    noticeRange: [33e4, 330400],
    businessErrorRange: [330401, 330800],
    systemErrorRange: [330801, 330999]
  },
  "/ma": {
    noticeRange: [241e3, 241400],
    businessErrorRange: [241401, 241800],
    systemErrorRange: [241801, 241999]
  },
  "/bffmall": {
    noticeRange: [28e4, 280400],
    businessErrorRange: [280401, 280800],
    systemErrorRange: [280801, 280999]
  },
  "/ucenterapi": {
    noticeRange: [0, 0],
    businessErrorRange: [201e3, 202e3],
    systemErrorRange: [0, 0]
  },
  "/commoditycenter": {
    noticeRange: [
      [516100, 516500],
      [515e3, 515400]
    ],
    businessErrorRange: [
      [516501, 516900],
      [515401, 515800]
    ],
    systemErrorRange: [
      [516900, 516999],
      [515801, 515999]
    ]
  }
};
function isInRange(code, ranges) {
  if (Array.isArray(ranges[0])) {
    return ranges.some((range) => code >= range[0] && code <= range[1]);
  }
  const [min, max] = ranges;
  return code >= min && code <= max;
}
function extractPath(url) {
  let normalizedUrl = url.startsWith("/") ? url : `/${url}`;
  try {
    const urlObj = new URL(url);
    normalizedUrl = urlObj.pathname;
  } catch (error) {
  }
  const segments = normalizedUrl.split("/");
  const firstPath = segments.filter(Boolean)[0];
  return firstPath ? `/${firstPath}` : "";
}
function checkResponseType(url, code) {
  const path = extractPath(url);
  if (!path) {
    return void 0;
  }
  const prefix = Object.keys(urlPrefixMap).find((key) => path === key);
  if (!prefix) {
    return void 0;
  }
  const ranges = urlPrefixMap[prefix];
  const numericCode = typeof code === "string" ? parseInt(code) : code;
  if (isInRange(numericCode, ranges.noticeRange)) {
    return ResponseType.BUSINESS_NOTICE;
  }
  if (isInRange(numericCode, ranges.businessErrorRange)) {
    return ResponseType.BUSINESS_ERROR;
  }
  if (isInRange(numericCode, ranges.systemErrorRange)) {
    return ResponseType.SYSTEM_ERROR;
  }
  return void 0;
}
export { ResponseType, checkResponseType };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/checkResponseType.js